// alarm-management.service.ts (Angular)
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlarmManagementModel } from '@models/alarm-management.model';
import { api } from '@consts/url.const';

@Injectable({
  providedIn: 'root',
})
export class AlarmManagementService {
  constructor(private http: HttpClient) {}

  checkActiveAlarm(locationId: string): Observable<AlarmManagementModel.AlarmCheckResponse> {
    return this.http.get<AlarmManagementModel.AlarmCheckResponse>(`${api.alarmManagement}/check/${locationId}`);
  }

  createAlarm(createAlarm: AlarmManagementModel.CreateAlarm): Observable<{ alarmId: string }> {
    return this.http.post<{ alarmId: string }>(`${api.alarmManagement}`, createAlarm);
  }

  cancelAlarm(cancelAlarm: AlarmManagementModel.CancelAlarm): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${api.alarmManagement}/cancel`, cancelAlarm);
  }

  cancelAlarmById(alarmId: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${api.alarmManagement}/${alarmId}` );
  }

  getActiveAlarms(): Observable<AlarmManagementModel.AlarmData[]> {
    return this.http.get<AlarmManagementModel.AlarmData[]>(`${api.alarmManagement}/active`);
  }

  getCanceledAlarms(): Observable<AlarmManagementModel.AlarmData[]> {
    return this.http.get<AlarmManagementModel.AlarmData[]>(`${api.alarmManagement}/canceled`);
  }

  getAlarmHistory(filter?: AlarmManagementModel.AlarmFilter): Observable<AlarmManagementModel.AlarmData[]> {
    const params: any = {};
    if (filter?.status !== undefined) params.status = filter.status;
    if (filter?.locationId) params.locationId = filter.locationId;
    if (filter?.fromDate) params.fromDate = filter.fromDate;
    if (filter?.toDate) params.toDate = filter.toDate;

    return this.http.get<AlarmManagementModel.AlarmData[]>(`${api.alarmManagement}/history`, { params });
  }

  getAlarmById(alarmId: string): Observable<AlarmManagementModel.AlarmData> {
    return this.http.get<AlarmManagementModel.AlarmData>(`${api.alarmManagement}/${alarmId}`);
  }
}
